import * as Sentry from '@sentry/react';

const isSentryEnabled = process.env.SENTRY_STATUS === 'true';

const init = args => {
  if (isSentryEnabled) {
    Sentry.init(args);
  }
};

const captureMessage = args => {
  if (isSentryEnabled) {
    Sentry.captureMessage(args);
  }
};

const withProfiler = args => {
  if (isSentryEnabled) {
    return Sentry.withProfiler(args);
  }
  return args;
};

export default {
  init,
  captureMessage,
  withProfiler,
};
